export const TRANSIENT_CITY_ID_PREFIX = "city-overview-";

export const computeBundleCost = (count) => {
  const total = Math.max(0, Number(count) || 0);
  if (total >= 10) return total - 2;
  if (total >= 5) return total - 1;
  return total;
};

export const isPurchasablePlace = (place) => (
  !!place?.id && !String(place.id).startsWith(TRANSIENT_CITY_ID_PREFIX)
);

export const isSelectableTourPlace = (place) => (
  isPurchasablePlace(place) || Boolean(place?.is_starting_point && place?.id)
);

export const getPurchaseSummary = ({ places = [], selectedIds = [], buyingAll = false }) => {
  const purchasablePlaces = places.filter(isSelectableTourPlace);
  const purchasableIds = new Set(purchasablePlaces.map((place) => place.id));
  const selectedPurchasableIds = Array.from(selectedIds).filter((id) => purchasableIds.has(id));
  const placeIds = buyingAll ? purchasablePlaces.map((place) => place.id) : selectedPurchasableIds;
  const credits = computeBundleCost(placeIds.length);
  const regularCredits = placeIds.length;

  return {
    placeIds,
    count: placeIds.length,
    credits,
    regularCredits,
    savedCredits: regularCredits - credits,
    hasDiscount: credits < regularCredits,
    purchasablePlaces,
  };
};
